export default class BmwEventNumbers {
    static modelName = 'BmwEventNumbers';
    id: number
    active: boolean = true
    bmwnumber: string
    description: string
    [key: string]: any
}